<template>
    <div class="contacts-list">
        <ion-list v-if="contacts && contacts.length > 0">
            <ion-item
                v-for="contact in sortedContacts"
                :key="contact.id"
                :style="`--background:${contact === selectedContact ? '#dfdfdf' : '#ffffff'};`"
                @click="selectContact(contact)"
            >
                <ion-avatar class="avatar">
                    <img
                        :src="
                            contact.approved_images[0]
                                ? `${constants.assetsUri}/${contact.approved_images[0].path}`
                                : require('../assets/imgupload-square.png')
                        "
                    />
                </ion-avatar>
                <div class="contact">
                    <p class="name">{{ contact.name }}</p>
                    <p class="last-message">
                        {{
                            contact.lastMessageTitle.length < 30
                                ? contact.lastMessageTitle
                                : contact.lastMessageTitle.substring(0, 30) + '...'
                        }}
                    </p>
                </div>
                <span class="unread" v-if="contact.unread">{{ contact.unread }}</span>
            </ion-item>
        </ion-list>
        <div v-else-if="hasContacts == false" class="empty-list">
            <p>
                {{ $t('chat.emptyContactsList') }}
                <br />
                <router-link to="/search">{{ $t('chat.search') }}</router-link>
                {{ $t('chat.emptyContactsList2') }}
            </p>
        </div>

        <div v-else>
            <ion-skeleton-text class="sending-skeleton" animated></ion-skeleton-text>
        </div>
    </div>
</template>

<script>
const _ = require('lodash')
import { constants } from '../constants'

export default {
    name: 'contacts-list',
    props: ['contacts'],
    data() {
        return {
            constants,
            selectedContact: null,
            hasContacts: {
                type: Boolean
            }
        }
    },
    methods: {
        selectContact: function(contact) {
            if (contact.id !== Number(this.$route.query.id)) {
                this.$router.push(`/messages?id=${contact.id}`)
            }
        }
    },
    computed: {
        sortedContacts() {
            return _.sortBy(this.contacts, [
                contact => {
                    if (contact) {
                        return contact.lastMessageId
                    }
                }
            ]).reverse()
        }
    },
    watch: {
        contacts(contacts) {
            if (contacts.length > 0) {
                this.hasContacts = true
            } else this.hasContacts = false
        }
    }
}
</script>

<style lang="scss" scoped>
.contacts-list {
    flex: 3;
    overflow-y: scroll;
    overflow-x: hidden;
    ion-list {
        padding-left: 0;
        list-style-type: none;

        ion-item {
            display: flex;
            height: 80px;
            cursor: pointer;

            span.unread {
                background: #82e8a8;
                color: #fff;
                right: 10px;
                top: 20px;
                display: flex;
                font-weight: 700;
                min-width: 20px;
                justify-content: center;
                align-items: center;
                line-height: 20px;
                font-size: 12px;
                padding: 0 4px;
                max-height: 20px;
                border-radius: 3px;
            }

            .avatar {
                flex: 1;
                display: flex;
                align-items: center;

                img {
                    width: 50px;
                    height: 50px;
                }
            }

            .contact {
                flex: 4;
                font-size: 12px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                justify-content: center;

                p {
                    margin: 0;

                    &.name {
                        font-size: 120%;
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .empty-list {
        font-size: 120%;
    }
}

@media (min-width: 768px) {
    ion-list {
        padding: 2% 4% !important;

        ion-item {
            margin-top: 20px;
        }

        p {
            font-size: 20px !important;
        }

        .avatar {
            img {
                width: 60px !important;
                height: 60px !important;
            }
        }
    }
}

@media (min-width: 1200px) {
    .contacts-list {
        overflow-y: hidden;

        ion-list {
            max-height: 700px;
            overflow-y: auto;
        }
    }
}
</style>
